<template>
	<div id="app">
		<router-view :key="$route.fullPath"></router-view>
	</div>
</template>

<script>
export default {
	name: 'App',
	metaInfo: {
		title: 'Atrévete a la aventura',
		titleTemplate: '%s | Sur Campers',
	},
}
</script>
